import { Injectable } from '@angular/core';

import { ApiService } from './api.service';
import { CONSTANTS } from '../../constants';

@Injectable({
    providedIn: 'root'
})
export class AccountService extends ApiService {

    public listAccounts() {
        return this.get(CONSTANTS.API.USERS.GET_USERS);
    }
    public addAccount(data: any) {
        return this.post(CONSTANTS.API.USERS.ADD_USER, data);
    }
    public getAccountDetails() {
        return this.get(CONSTANTS.API.USERS.GET_ACCOUNT);
    }
    public updateAccount(data: any) {
        return this.post(CONSTANTS.API.USERS.UPDATE_USER, data);
    }
    public deleteAccount(data: any) {
        return this.getQueryParams(CONSTANTS.API.USERS.DELETE_USER, data);
    }
    public activateAccount(data: any) {
        return this.getQueryParams(CONSTANTS.API.USERS.ACTIVATE_USER, data);
    }
    public resetPassword(data: any) {
        return this.post(CONSTANTS.API.USERS.RESET_PASSWORD, data);
    }
    public chnagePassword(data: any) {
        return this.post(CONSTANTS.API.USERS.CHANGE_PASSWORD, data);
    }
    public getProfile(data: any) {
        return this.getQueryParams(CONSTANTS.API.USERS.GET_PROFILE, data);
    }
}
